import { useTranslation } from 'react-i18next';

export default function ServicesHeader() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20wide%20elegant%20view%20of%20a%20modern%20Swiss%20office%20and%20residential%20building%20complex%20with%20clean%20geometric%20architecture%2C%20glass%20and%20warm%20stone%20facades%2C%20perfectly%20maintained%20surroundings%2C%20soft%20golden%20natural%20light%2C%20muted%20sage%20green%20and%20warm%20neutral%20tones%2C%20editorial%20architectural%20photography%2C%20high%20detail%2C%20professional%20and%20trustworthy%20atmosphere&width=1600&height=900&seq=limpia-hero-services&orientation=landscape"
          alt={t('servicesPage.header.title')}
          title={t('servicesPage.header.title')}
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 pt-36 md:pt-48 pb-20 md:pb-28">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/20 text-background-50 text-xs font-semibold tracking-[0.2em] uppercase mb-6">
            <i className="ri-sparkling-line"></i>
            {t('servicesPage.header.badge')}
          </span>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight mb-6">
            {t('servicesPage.header.title')}
          </h1>
          <p className="text-background-50/85 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto">
            {t('servicesPage.header.description')}
          </p>
        </div>
      </div>
    </section>
  );
}